import {Directive, Input, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appSearchCriterionForm]'
})
export class SearchCriterionFormDirective {

    constructor(public viewContainerRef: ViewContainerRef) {}
}
